import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import {
  buildDonorNameWarning,
  DONOR_NAME_DETECTED_TEXT,
} from './donorNameFlagUtils';

interface DonorNameWarningProps {
  fieldLabels?: string[];
  variant?: 'full' | 'short';
  className?: string;
}

const StyledDonorNameWarning = styled(TrueImpactText)`
  max-width: 540px;
  margin: ${SPACERS.tiny} auto 0;
  text-align: left;
`;

const DonorNameWarning: React.FC<DonorNameWarningProps> = ({
  fieldLabels = [],
  variant = 'full',
  className,
}) => (
  <StyledDonorNameWarning
    color="critical"
    variant="body-small"
    className={className}
  >
    {variant === 'short'
      ? DONOR_NAME_DETECTED_TEXT
      : buildDonorNameWarning(fieldLabels)}
  </StyledDonorNameWarning>
);

export default DonorNameWarning;
